import { Component } from '@angular/core';

@Component({
    selector: 'app-buyer-page-options',
    templateUrl: './buyer-page-options.component.html',
    styleUrls: ['./buyer-page-options.component.scss'],
    standalone: true
})
export class BuyerPageOptionsComponent {

}
